import { render, staticRenderFns } from "./request_awb.vue?vue&type=template&id=9f496d9e&scoped=true&"
import script from "./request_awb.vue?vue&type=script&lang=js&"
export * from "./request_awb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f496d9e",
  null
  
)

export default component.exports